module.exports = __webpack_public_path__ + "img/fadian_apple.a65fa656.jpg";